"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.NEUTRAL_PROVIDER_AVATAR_URL = exports.MALE_PROVIDER_AVATAR_URL = exports.FEMALE_PROVIDER_AVATAR_URL = void 0;
const MALE_PROVIDER_AVATAR_URL = exports.MALE_PROVIDER_AVATAR_URL = 'https://cdn.kyruus.com/pm-dev/assets/provider-avatar-male-rectangle.png';
const FEMALE_PROVIDER_AVATAR_URL = exports.FEMALE_PROVIDER_AVATAR_URL = 'https://cdn.kyruus.com/pm-dev/assets/provider-avatar-female-rectangle.png';
const NEUTRAL_PROVIDER_AVATAR_URL = exports.NEUTRAL_PROVIDER_AVATAR_URL = 'https://cdn.kyruus.com/pm-dev/assets/provider-avatar-neutral-rectangle.png';